
//:key="$route.fullPath"
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class contact extends Vue {
  name: String = "contact";
}
